/* tslint:disable */
/* eslint-disable */
/**
 * New Train Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { GetMinPriceResponse } from '../model';
// @ts-ignore
import { GetPricingResult } from '../model';
// @ts-ignore
import { ProblemDetails } from '../model';
/**
 * PricesApiApiGetMinPricesGet - axios parameter creator
 * 
 * @summary Get min price of train
 * @param {number} [from] 
 * @param {number} [to] 
 * @param {string} [fromDate] 
 * @param {string} [toDate] 
 * @param {number} [capacity] 
 * @param {number} [genderCode] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PricesApiApiGetMinPricesGetAxiosParamCreator (from?: number, to?: number, fromDate?: string, toDate?: string, capacity?: number, genderCode?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GetMinPrices`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (from !== undefined) {
        localVarQueryParameter['From'] = from;
    }

    if (to !== undefined) {
        localVarQueryParameter['To'] = to;
    }

    if (fromDate !== undefined) {
        localVarQueryParameter['FromDate'] = (fromDate as any instanceof Date) ?
            (fromDate as any).toISOString() :
            fromDate;
    }

    if (toDate !== undefined) {
        localVarQueryParameter['ToDate'] = (toDate as any instanceof Date) ?
            (toDate as any).toISOString() :
            toDate;
    }

    if (capacity !== undefined) {
        localVarQueryParameter['Capacity'] = capacity;
    }

    if (genderCode !== undefined) {
        localVarQueryParameter['GenderCode'] = genderCode;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PricesApiApiGetMinPricesV2Get - axios parameter creator
 * 
 * @summary Get min price of train (version 2)
 * @param {number} [from] 
 * @param {number} [to] 
 * @param {string} [fromDate] 
 * @param {string} [toDate] 
 * @param {number} [capacity] 
 * @param {number} [genderCode] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PricesApiApiGetMinPricesV2GetAxiosParamCreator (from?: number, to?: number, fromDate?: string, toDate?: string, capacity?: number, genderCode?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GetMinPrices/v2`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (from !== undefined) {
        localVarQueryParameter['From'] = from;
    }

    if (to !== undefined) {
        localVarQueryParameter['To'] = to;
    }

    if (fromDate !== undefined) {
        localVarQueryParameter['FromDate'] = (fromDate as any instanceof Date) ?
            (fromDate as any).toISOString() :
            fromDate;
    }

    if (toDate !== undefined) {
        localVarQueryParameter['ToDate'] = (toDate as any instanceof Date) ?
            (toDate as any).toISOString() :
            toDate;
    }

    if (capacity !== undefined) {
        localVarQueryParameter['Capacity'] = capacity;
    }

    if (genderCode !== undefined) {
        localVarQueryParameter['GenderCode'] = genderCode;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PricesApiApiGetPricingGet - axios parameter creator
 * 
 * @summary Get price for ages
 * @param {number} [capacityId] 
 * @param {number} [adultCount] 
 * @param {number} [childCount] 
 * @param {number} [infantCount] 
 * @param {number} [emptySeatCount] 
 * @param {number} [foreignerCount] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PricesApiApiGetPricingGetAxiosParamCreator (capacityId?: number, adultCount?: number, childCount?: number, infantCount?: number, emptySeatCount?: number, foreignerCount?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GetPricing`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (capacityId !== undefined) {
        localVarQueryParameter['CapacityId'] = capacityId;
    }

    if (adultCount !== undefined) {
        localVarQueryParameter['AdultCount'] = adultCount;
    }

    if (childCount !== undefined) {
        localVarQueryParameter['ChildCount'] = childCount;
    }

    if (infantCount !== undefined) {
        localVarQueryParameter['InfantCount'] = infantCount;
    }

    if (emptySeatCount !== undefined) {
        localVarQueryParameter['EmptySeatCount'] = emptySeatCount;
    }

    if (foreignerCount !== undefined) {
        localVarQueryParameter['ForeignerCount'] = foreignerCount;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiGetMinPricesGet operation in PricesApi.
 * @export
 * @interface PricesApiApiGetMinPricesGetRequest
 */
export interface PricesApiApiGetMinPricesGetRequest {
    /**
     * 
     * @type {number}
     * @memberof PricesApiApiGetMinPricesGet
     */
    readonly from?: number

    /**
     * 
     * @type {number}
     * @memberof PricesApiApiGetMinPricesGet
     */
    readonly to?: number

    /**
     * 
     * @type {string}
     * @memberof PricesApiApiGetMinPricesGet
     */
    readonly fromDate?: string

    /**
     * 
     * @type {string}
     * @memberof PricesApiApiGetMinPricesGet
     */
    readonly toDate?: string

    /**
     * 
     * @type {number}
     * @memberof PricesApiApiGetMinPricesGet
     */
    readonly capacity?: number

    /**
     * 
     * @type {number}
     * @memberof PricesApiApiGetMinPricesGet
     */
    readonly genderCode?: number
}

/**
 * Request parameters for apiGetMinPricesV2Get operation in PricesApi.
 * @export
 * @interface PricesApiApiGetMinPricesV2GetRequest
 */
export interface PricesApiApiGetMinPricesV2GetRequest {
    /**
     * 
     * @type {number}
     * @memberof PricesApiApiGetMinPricesV2Get
     */
    readonly from?: number

    /**
     * 
     * @type {number}
     * @memberof PricesApiApiGetMinPricesV2Get
     */
    readonly to?: number

    /**
     * 
     * @type {string}
     * @memberof PricesApiApiGetMinPricesV2Get
     */
    readonly fromDate?: string

    /**
     * 
     * @type {string}
     * @memberof PricesApiApiGetMinPricesV2Get
     */
    readonly toDate?: string

    /**
     * 
     * @type {number}
     * @memberof PricesApiApiGetMinPricesV2Get
     */
    readonly capacity?: number

    /**
     * 
     * @type {number}
     * @memberof PricesApiApiGetMinPricesV2Get
     */
    readonly genderCode?: number
}

/**
 * Request parameters for apiGetPricingGet operation in PricesApi.
 * @export
 * @interface PricesApiApiGetPricingGetRequest
 */
export interface PricesApiApiGetPricingGetRequest {
    /**
     * 
     * @type {number}
     * @memberof PricesApiApiGetPricingGet
     */
    readonly capacityId?: number

    /**
     * 
     * @type {number}
     * @memberof PricesApiApiGetPricingGet
     */
    readonly adultCount?: number

    /**
     * 
     * @type {number}
     * @memberof PricesApiApiGetPricingGet
     */
    readonly childCount?: number

    /**
     * 
     * @type {number}
     * @memberof PricesApiApiGetPricingGet
     */
    readonly infantCount?: number

    /**
     * 
     * @type {number}
     * @memberof PricesApiApiGetPricingGet
     */
    readonly emptySeatCount?: number

    /**
     * 
     * @type {number}
     * @memberof PricesApiApiGetPricingGet
     */
    readonly foreignerCount?: number
}

/**
* 
* @summary Get min price of train
* @param {PricesApiApiGetMinPricesGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PricesApiApiGetMinPricesGet(requestParameters: PricesApiApiGetMinPricesGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PricesApiApiGetMinPricesGetAxiosParamCreator(requestParameters.from, requestParameters.to, requestParameters.fromDate, requestParameters.toDate, requestParameters.capacity, requestParameters.genderCode, options, configuration);
    const request: () => AxiosPromise<{ [key: string]: string; }> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Get min price of train (version 2)
* @param {PricesApiApiGetMinPricesV2GetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PricesApiApiGetMinPricesV2Get(requestParameters: PricesApiApiGetMinPricesV2GetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PricesApiApiGetMinPricesV2GetAxiosParamCreator(requestParameters.from, requestParameters.to, requestParameters.fromDate, requestParameters.toDate, requestParameters.capacity, requestParameters.genderCode, options, configuration);
    const request: () => AxiosPromise<Array<GetMinPriceResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Get price for ages
* @param {PricesApiApiGetPricingGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PricesApiApiGetPricingGet(requestParameters: PricesApiApiGetPricingGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PricesApiApiGetPricingGetAxiosParamCreator(requestParameters.capacityId, requestParameters.adultCount, requestParameters.childCount, requestParameters.infantCount, requestParameters.emptySeatCount, requestParameters.foreignerCount, options, configuration);
    const request: () => AxiosPromise<GetPricingResult> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
